const theme = {
  black: '#1E2328',
  green: '#14A670',
  yellow: '#C99402',
  backgroundGrey: '#F9F9F9',
  backgroundWhite: 'white',
  grey: '#707A8A',
  buttonYellow: '#FCD435',
  red: '#CF3049',
};

export default theme;
